import { Link } from "react-router-dom";
import SourceBadge from "@/components/SourceBadge";
import SentimentBadge from "@/components/SentimentBadge";
import InitialsAvatar from "@/components/InitialsAvatar";
import { formatRelativeDate } from "@/lib/utils";
import { ExternalLink } from "lucide-react";

export default function MentionCard({ mention, hideTicker = false, hideExpert = false }) {
  return (
    <article
      data-testid={`mention-card-${mention.id}`}
      className="group border border-[#1e293b] bg-[#111827] p-4 transition-colors hover:border-[#334155]"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          {!hideExpert && (
            <>
              <InitialsAvatar
                name={mention.expert_name}
                expertId={mention.expert_id}
                size="md"
              />
              <div>
                <Link
                  to={`/expert/${mention.expert_id}`}
                  data-testid={`mention-expert-link-${mention.id}`}
                  className="block text-sm font-semibold text-[#f8fafc] hover:text-[#60a5fa]"
                >
                  {mention.expert_name}
                </Link>
                <div className="font-mono text-[10px] uppercase tracking-wider text-[#64748b]">
                  {formatRelativeDate(mention.date)}
                </div>
              </div>
            </>
          )}
          {hideExpert && (
            <div>
              <div className="font-mono text-[10px] uppercase tracking-wider text-[#64748b]">
                {formatRelativeDate(mention.date)}
              </div>
            </div>
          )}
        </div>
        {!hideTicker && (
          <Link
            to={`/ticker/${mention.ticker}`}
            data-testid={`mention-ticker-link-${mention.id}`}
            className="mono text-sm font-semibold text-[#3b82f6] hover:text-[#60a5fa]"
          >
            {mention.ticker}
          </Link>
        )}
      </div>

      <p className="mt-3 text-[13.5px] leading-relaxed text-[#cbd5e1]">
        {mention.summary}
      </p>

      {mention.quote && (
        <blockquote className="mt-3 border-l-2 border-[#3b82f6]/60 pl-3 text-[12px] italic leading-relaxed text-[#94a3b8]">
          “{mention.quote}”
        </blockquote>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <SourceBadge source={mention.source} sourceName={mention.source_name} />
        <SentimentBadge sentiment={mention.sentiment} />
        {!hideTicker && (
          <span className="font-mono text-[10px] uppercase tracking-wider text-[#64748b]">
            · {mention.company}
          </span>
        )}
        {mention.source_url && (
          <a
            href={mention.source_url}
            target="_blank"
            rel="noreferrer noopener"
            data-testid={`mention-source-link-${mention.id}`}
            className="ml-auto inline-flex items-center gap-1 border border-[#1e293b] px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-[#94a3b8] transition-colors hover:border-[#3b82f6] hover:text-[#60a5fa]"
          >
            <ExternalLink className="h-3 w-3" /> Source
          </a>
        )}
      </div>
    </article>
  );
}
